import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateService } from '@ngx-translate/core';
import { Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { Logger } from './shared/services/logger.service';
import { environment } from '../environments/environment';
import { UserService } from './shared/services/user.service';

/**
 * Handles missing translations
 */
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  /**
   * Handle of missing translations
   * @param {MissingTranslationHandlerParams} params Missing translation handler params
   */
  handle(params: MissingTranslationHandlerParams) {
    if (environment.production) {
      return; // Display string from default language
    } else {
      Logger.error('Missing string (key: ' + params.key + ', language: ' + params.translateService.currentLang + ')');
      return; // Can be modified if it should not display the default language string
    }
  }
}

/**
 * Http Loader
 * @param {HttpClient}            http HttpClient
 * @returns {TranslateHttpLoader} TranslateHttpLoader
 */
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

/**
 * Lets the app wait until the language files are loaded. After that, it is safe to use the function 'translate.instant'.
 * @param {TranslateService}      translate TranslateService
 * @param {Injector}              injector Injector
 * @returns {() => Promise<any>}
 */
export function appInitializerFactory(translate: TranslateService, injector: Injector, userService: UserService) {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

    locationInitialized.then(() => {
      const langToSet = 'de';
      translate.setDefaultLang(langToSet);

      translate.use(langToSet).subscribe(() => {
        // Language loaded successfully
      }, () => {
        Logger.error('Problem with \'' + langToSet + '\' language initialization.');
      }, () => {
        resolve(null);
      });

      userService.currentUser.subscribe(user =>  {
        if (user) {
          translate.use(user.language);
          translate.setDefaultLang(user.language);
          /** Set HTML Lang for Accessibility */
          document.querySelector('html').setAttribute('lang', user.language);
        }
      });
    });
  });
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/app-translations.ts